import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import BlockMaxWidthHandler from '@/shared/content/blocks/helpers/BlockMaxWidthHandler.vue';
import OutletProductDetail from '@/shared/product/details/ui/outlet/OutletProductDetail.vue';
import OutletProductDetailPurchase from '@/storecontext/product/ui/OutletProductDetailPurchase.vue';
import useOutletProductDetailData from '@/shared/product/details/ui/outlet/useOutletProductDetailData';
import { StoreOutletProductDetailTileModel } from '@/types/StoreContextContentServerContract';
import BlockList from '@/shared/content/blocks/helpers/BlockList.vue';
import { onUnmounted } from 'vue';
import useBasket from '@/storecontext/basket/useBasket';
import { provideBuyXAndGetYPercent } from '@/shared/checkout/basket/useBuyXAndGetYPercent';


export default /*#__PURE__*/_defineComponent({
  __name: 'StoreContextOutletProductDetailTile',
  props: {
    content: null
  },
  setup(__props: any) {

const props = __props as {
    content: StoreOutletProductDetailTileModel
}



const { setOutletProductData, clearOutletProductData } = useOutletProductDetailData();
setOutletProductData(props.content.productDetail);
onUnmounted(clearOutletProductData);
const { buyXAndGetYPctDiscount } = useBasket();
provideBuyXAndGetYPercent(buyXAndGetYPctDiscount);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(BlockMaxWidthHandler, null, {
      default: _withCtx(() => [
        _createVNode(OutletProductDetail, null, {
          default: _withCtx(() => [
            _createVNode(OutletProductDetailPurchase)
          ]),
          _: 1
        }),
        _createVNode(BlockList, {
          blocks: __props.content.tiles
        }, null, 8, ["blocks"])
      ]),
      _: 1
    })
  ]))
}
}

})